/*global mixpanel,MIXPANEL_CUSTOM_LIB_URL*/
import config from 'config'

let _loaded = false
let _userIdentifiedPromise

function init() {
	if (_loaded) {
		return
	}
	_loaded = true;
	(function(e, a) {
		if (!a.__SV) {
			var b=window;try {
				var c, l, i, j=b.location, g=j.hash;c=function(a, b) {
					// eslint-disable-next-line no-cond-assign
					return (l=a.match(RegExp(b+'=([^&]*)')))?l[1]:null
				};g&&c(g, 'state')&&(i=JSON.parse(decodeURIComponent(c(g, 'state'))), 'mpeditor'===i.action&&(b.sessionStorage.setItem('_mpcehash', g), history.replaceState(i.desiredHash||'', e.title, j.pathname+j.search)))
			} catch (m) {} var k, h;window.mixpanel=a;a._i=[];a.init=function(b, c, f) {
				function e(b, a) {
					var c=a.split('.');2==c.length&&(b=b[c[0]], a=c[1]);b[a]=function() {
						b.push([a].concat(Array.prototype.slice.call(arguments,
							0)))
					}
				} var d=a;'undefined'!==typeof f?d=a[f]=[]:f='mixpanel';d.people=d.people||[];d.toString=function(b) {
					var a='mixpanel';'mixpanel'!==f&&(a+='.'+f);b||(a+=' (stub)');return a
				};d.people.toString=function() {
					return d.toString(1)+'.people (stub)'
				};k='disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user'.split(' ')
				for (h=0;h<k.length;h++)e(d, k[h]);a._i.push([b, c, f])
			};a.__SV=1.2;b=e.createElement('script');b.type='text/javascript';b.async=!0;b.src='undefined'!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:'file:'===e.location.protocol&&'//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js'.match(/^\/\//)?'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js':'//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';c=e.getElementsByTagName('script')[0];c.parentNode.insertBefore(b, c)
		}
	})(document, window.mixpanel||[])
	mixpanel.init(config.mixpanel.clientId)
}

function identifyUser(presenterUid) {
	if (!_userIdentifiedPromise) {
		_userIdentifiedPromise = new Promise(function(resolve) {
			if (typeof mixpanel !== 'undefined') {
				mixpanel.identify(presenterUid)
				resolve()
			} else {
				resolve()
			}
		})
	}
	return _userIdentifiedPromise
}

function track(event, properties, needsCallback) {
	return new Promise(function(resolve) {

		function dispatchSuccess() {
			resolve()
		}
		var _callback = needsCallback ? dispatchSuccess : null

		if (typeof mixpanel !== 'undefined') {
			mixpanel.track(event, properties, _callback)
		}
		if (!needsCallback) {
			resolve()
		} else {
			setTimeout(dispatchSuccess, 500)
		}
	})
}

function alias(presenterUid) {
	return new Promise(function(resolve) {
		if (typeof mixpanel !== 'undefined') {
			mixpanel.alias(presenterUid)
		}
		resolve()
	})
}

function reset() {
	return new Promise(function(resolve) {
		if (typeof mixpanel !== 'undefined') {
			mixpanel.reset()
		}
		resolve()
	})
}

function setPeopleProperties(props) {
	return new Promise(function(resolve) {
		if (typeof mixpanel !== 'undefined') {
			mixpanel.people.set(props)
		}
		resolve()
	})
}

function waitForUserIdentification() {
	return _userIdentifiedPromise
}

function getDistinctId() {
	return new Promise(function(resolve) {
		let distinctId = ''
		if (typeof mixpanel !== 'undefined') {
			distinctId = mixpanel.get_distinct_id()
		}
		resolve(distinctId)
	})
}

export default {
	init,
	identify: identifyUser,
	waitForUserIdentification,
	alias,
	reset,
	setPeopleProperties,
	track,
	getDistinctId,
}
